import ObserverSelect from './Select';
export default ObserverSelect;
